__webpack_require__.p = "/1.0.7610-bugfix-specs-page/dist/";